import React, { useState } from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

const faqData = [
  {
    question: "What is Hobi?",
    answer: "Hobi is a platform that helps you discover and book curated activities that match your interests, mood, and vibe. From creative workshops to outdoor adventures, we've got something for everyone."
  },
  {
    question: "How do I book an event?",
    answer: "Simply browse through our events, select the one you like, choose your tickets, and complete the payment. You'll receive a confirmation email with all the details."
  },
  {
    question: "Can I cancel my booking?",
    answer: "Cancellation policies vary by event. Please check the specific event's cancellation policy before booking. Most events allow cancellations up to 24-48 hours before the event."
  },
  {
    question: "How do I become an event organizer?",
    answer: "If you're interested in hosting events on Hobi, visit our 'For Businesses' section or contact us directly. We'd love to have passionate organizers join our platform."
  },
  {
    question: "Is my payment secure?",
    answer: "Yes! We use industry-standard encryption and secure payment gateways to ensure your payment information is always protected."
  },
  {
    question: "How do I contact support?",
    answer: "You can reach our support team through the Contact page, or email us directly at support@hobi.com. We typically respond within 24 hours."
  }
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="static-page-wrapper hero-bg-listing-creative">
      <Navbar dark={true} />
      
      <div className="static-page-hero">
        <h1 className="static-page-title">FAQ</h1>
        <p className="static-page-subtitle">Find answers to common questions about Hobi</p>
      </div>

      <main className="static-page-content">
        <div className="static-page-container">
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFaq(index)}
                >
                  <span>{faq.question}</span>
                  <svg 
                    className="faq-icon" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                  >
                    <path d={openIndex === index ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} />
                  </svg>
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
